import { render, staticRenderFns } from "./Oauth.vue?vue&type=template&id=b2fa597e&scoped=true&"
import script from "./Oauth.vue?vue&type=script&lang=js&"
export * from "./Oauth.vue?vue&type=script&lang=js&"
import style0 from "./Oauth.vue?vue&type=style&index=0&id=b2fa597e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fa597e",
  null
  
)

export default component.exports